<!-- 新增租约 -->
<template>
    <div id="addOldLease">
      <a-form layout="vertical" :form="leaseForm" selfUpdate>
        <div class="greyDiv">
          <a-row>
            <!-- 所在大厦 -->
            <a-col :span="8">
              <a-form-item   :label="$t('keyyuandasha')">
                <a-select
                  :disabled="unitVO != null"
                  :placeholder="$t('lease.modal.buildingTip')" v-decorator="decorators.mansion"
                  showSearch
                  :defaultActiveFirstOption="false"
                  :showArrow="false"
                  :filterOption="false"
                  @search="initMansionOptions"
                  :notFoundContent="null"
                  @change="mansionIdChange"
                >
                  <a-icon slot="suffixIcon" type="caret-down" />
                  <div slot="dropdownRender" slot-scope="menu">
                    <v-nodes :vnodes="menu" />
                    <a-divider style="margin: 0;" />
                    <div class="addBottomBtn" @click="openAddMansionModal">
                      <pt-icon type="icon-zengjia" class="addIcon"></pt-icon>
                      <div class="addBtnText">{{$t('mansion.addMansion.addTitle')}}</div>
                    </div>
                  </div>
                  <a-select-option v-for="m in mansionOptions" :key="m.id" :value="m.id"><div style="display: flex;overflow: hidden;justify-content: space-between"><div style="flex: auto;overflow: hidden;white-space: nowrap;text-overflow: ellipsis">{{m.name}}</div><div>{{m.province == 'hk'?'HK':m.citys}}</div></div></a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <!-- 租金 -->
            <a-col :span="8">
              <a-form-item   :label="$t('lease.modal.rent')">
                <a-input-group compact>
                  <pt-input-number  style="width:55%;" :max="99999" :precision="2" :placeholder="$t('lease.modal.inputTip')" v-decorator="decorators.rent"></pt-input-number>
                  <pt-unit-select style="width: 45%;" type="rent" v-model="defaultRentUnit" disabled></pt-unit-select>
                </a-input-group>
              </a-form-item>
            </a-col>
            <!-- 免租期（月） -->
            <a-col :span="8">
              <a-form-item :label="$t('keyzuqi')">
                <pt-month-range :placeholder="[$t('mineDealAddOldLease.startMonth'),$t('mineDealAddOldLease.endMonth')]"  style="width:100%;" v-model="dateRange" :dataButtonShow="true">
                  <a-icon slot="suffixIcon" style="color:rgba(0, 0, 0, 0.25);padding-left:5px;" type="calendar" />
                </pt-month-range>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row class="lease_floor" v-if="leaseLeaseInfoDetailsVOList">
            <pt-newObjectTag v-if="unitVO == null" @click="addFloor" style="position: absolute;right: 8px;top: 8px;z-index:2;"></pt-newObjectTag>
            <div v-for="f,index in leaseLeaseInfoDetailsVOList" :key="index">
              <a-form-item v-show="false">
                <a-input
                  v-decorator="[`leaseLeaseInfoDetailsVOList[${index}].leaseId`]"
                ></a-input>
              </a-form-item>
              <a-form-item v-show="false">
                <a-input
                  v-decorator="[`leaseLeaseInfoDetailsVOList[${index}].mansionId`]"
                ></a-input>
              </a-form-item>
              <!-- 所在楼层 -->
              <a-col :span="8">
                <a-form-item :label="index == 0 ? $t('lease.detail.LeaseLeaseinfoDetailsDO.floor') : null">
                  <pt-select
                    :showSearch="true"
                    :disabled="unitVO != null"
                    v-decorator="[`leaseLeaseInfoDetailsVOList[${index}].floorId`,{rules: [

                      ],}]"
                    :placeholder="$t('lease.modal.selectTip')"
                  >
                    <a-select-option v-for="f in floorOptions" :key="f.id" :value="f.id">{{f.floorNum}}</a-select-option>
                  </pt-select>
                </a-form-item>
              </a-col>
              <!-- 单元号 -->
              <a-col :span="8">
                <a-form-item :label="index == 0 ? $t('lease.detail.LeaseLeaseinfoDetailsDO.unitCodes') : null">
                  <pt-input
                    :disabled="unitVO != null"
                    v-decorator="[`leaseLeaseInfoDetailsVOList[${index}].unitCodes`,{rules: [
                     {max:100,message:$t('lease.modal.unitCodeLengthTip')},
                    ],}]"
                    :placeholder="$t('lease.modal.inputTip')"
                  ></pt-input>
                </a-form-item>
              </a-col>
              <!-- 面积 -->
              <a-col :span="7">
                <a-form-item :label="index == 0 ? $t('lease.detail.LeaseLeaseinfoDetailsDO.areaSize') : null">
                  <a-input-group compact>
                    <pt-input-number  style="width: 60%" :max="99999" :precision="2"
                      :disabled="unitVO != null"
                      v-decorator="[`leaseLeaseInfoDetailsVOList[${index}].areaSize`,{}]"
                      :placeholder="$t('lease.modal.areaTip')"
                    >
                    </pt-input-number>
                    <pt-unit-select style="width: 40%;" type="area" v-model="defaultAreaUnit"
                                    disabled></pt-unit-select>
                  </a-input-group>
                </a-form-item>
              </a-col>
              <a-col :span="1">
                <a-form-item :label="null" v-if="index > 0" style="padding:0px 0px">
                  <div class="deleteBtn" @click="deleteFloorRow(index)" :style="index==0 ? 'margin-top:30px':''">
                    <pt-icon type="icon-tubiao" class="delIcon" style="padding-right:5px;"></pt-icon>
                  </div>
                </a-form-item>
              </a-col>
            </div>
          </a-row>
        </div>
      </a-form>
      <pt-modal :title="customerModalTitle" :visible="customerModalVisible"
                @ok="saveCustomer" @cancel="cancelAddCustomer" :width="800"
      >
        <div slot="content">
          <add-customer ref="customerModel" v-model="customerModalTitle" @saveSuccess="saveSuccess"></add-customer>
        </div>
      </pt-modal>
      <pt-modal :title="$t('mansion.addMansion.addTitle')" :visible="addMansionVisible"
                @ok="addMansion" @cancel="cancelAddMansion" :width="800"
      >
        <div slot="content">
          <quickly-add-mansion ref="addMansionRef" @saveSuccess="saveMansionSuccess"></quickly-add-mansion>
        </div>
      </pt-modal>
    </div>
</template>

<script>
  import moment from 'moment'
  import customerApi from '@/api/mine/customer'
  import mansionApi from '@/api/database/mansion'
  import mansionFloorApi from '@/api/database/mansionFloor'
  import leaseApi from '@/api/database/lease'
  import colleagueApi from '@/api/database/colleague'


  import QuicklyAddMansion from '../../database/mansionData/quicklyAddMansion'

  export default {
    name: 'addLease',
    components:{
      QuicklyAddMansion,
      VNodes: {
        functional: true,
        render: (h, ctx) => ctx.props.vnodes,
      },
    },
    props:{
      showAttachment:{
        type:Boolean,
        default: true,
      },
      stockStatusId:{
        type:String,
        default:null
      },
      defaultLeaseInfoVO:{},
      customerVO:{},
      unitVO:{},
      companyShow:{
        type:Boolean,
        default:true
      },
      leaseId:{
        type:String,
        default:undefined
      },
      dealId:{
        type:String,
        default:null
      },
      stockAreaUnit:{},
      stockRentUnit:{},
      defaultAreaUnit: {
        type:String,
        default:null,
      },
      defaultRentUnit: {
        type:String,
        default:null,
      },
      defaultCustomerId:{
        type: String,
        default:undefined
      },
    },
    data(){
      return{
        currMansionId:null,
        addMansionVisible:false,
        customerModalVisible: false,
        customerModalTitle:'',
        dateRange: null,
        leaseInfoVO: {},
        leaseLeaseInfoDetailsVOList:[{}],
        mansionOptions:[],
        colleagueList:[],
        competitors:[],
        floorOptions:[],
        leaseForm: this.$form.createForm(this,{}),
        fileList:[],
        customerList:[],
        decorators:{
          customerId:[

          ],
          mansion:[
            'mansion',{}
          ],
          floorId:[
            'floorId',{}
          ],
          unitCode:[
            'unitCode',{}
          ],
          leaseArea:[
            'leaseArea',{}
          ],
          areaSizeUnit:[
            'areaSizeUnit',{}
          ],
          rent:[
            'rent',{}
          ],
          rentUnit:[
            'rentUnit',{}
          ],
          startTime:[
            'startTime',{}
          ],
          endTime:[
            'endTime',{}
          ],
          propertyType:[
            'propertyType',{}
          ],
          remarks:['remarks',{rules:[{max:1024,message:this.$t('news.contentMaxLenTip')}]}],
          dueDatePrice:[
            'dueDatePrice',{rules:[{max:100,message:this.$t('news.increasingLenTip')}]}
            ],
          rentFreePeriod:['rentFreePeriod',{rules:[{max:100,message:this.$t('news.increasingLenTip')}]
          }],
          inTime:['inTime',{}],
          signTime:['signTime',{}],
          agent:['agent',{}],
          competeAgent:['competeAgent',{rules:[{max:256,message:this.$t('news.contentLenTip')}]}],
          dueTime:['dueTime',{initialValue:undefined}],
        }
      }
    },
    computed:{
      ranges() {
        let selectTime = this.$t('statistics.dealStatistics.selectTime')
        let arr = {}
        selectTime.forEach(data => {
          arr[data.name] = this.getRange(data.value)
        })
        return arr
      },
    },
    mounted(){
      this.init();
    },
    methods:{
      getRange(type) {
        let result = null
        switch (type) {
          case 1:
            result = [moment().subtract(7, 'days'), moment()]
            break
          case 2:
            result = [moment().subtract(30, 'days'), moment()]
            break
          case 3:
            result = [moment().subtract(90, 'days'), moment()]
            break
          case 4:
            result = [moment().startOf('month'), moment().endOf('month')]
            break
          case 5:
            result = [moment().startOf('quarter'), moment().endOf('quarter')]
            break
          case 6:
            result = [moment().startOf('year'), moment().endOf('year')]
            break
        }
        return result
      },
      addMansion(){
        this.$refs.addMansionRef.submit();
      },
      cancelAddMansion(){
        this.addMansionVisible = false;
      },
      saveMansionSuccess(mansionId,mansionName){
        let newMansionObj = {
          id:mansionId,
          name:mansionName
        }
        this.mansionOptions = [];
        this.mansionOptions.push(newMansionObj);
        this.leaseForm.setFieldsValue({
          mansion: mansionId
        });
        this.clearFloorList();
        this.initMansionFloorOptions(mansionId);
        this.addMansionVisible = false;
      },
      openAddMansionModal(){
        this.addMansionVisible = true;
      },
      addFloor(){
        this.leaseLeaseInfoDetailsVOList.push({});
        let keys = this.leaseForm.getFieldValue('leaseLeaseInfoDetailsVOList');
        keys.push({
          areaSizeUnit: this.defaultAreaUnit,
          mansionId:this.currMansionId,
          leaseId: this.currLeaseId,
          floorId:undefined,
          unitCodes:undefined,
          areaSize:undefined,
        });
        this.$nextTick(()=>{
          this.leaseForm.setFieldsValue({
            leaseLeaseInfoDetailsVOList: keys
          })
        })
      },
      cancelAddCustomer(){
        this.customerModalVisible = false;
      },
      customerIdChange(value){
        this.$emit('customerIdChange',value)
      },
      deleteFloorRow(index){
        let keys = this.leaseForm.getFieldValue('leaseLeaseInfoDetailsVOList');
        this.leaseForm.setFieldsValue({
          leaseLeaseInfoDetailsVOList: keys.filter((item,i) => index !== i),
        })
        this.leaseLeaseInfoDetailsVOList.splice(index,1);
      },
      delFile(index){
        this.fileList.splice(index,1);
      },
      extractLeaseInfoVO(){
        let leaseLeaseInfoVO = null;
        let curAreaSizeUnit = this.defaultAreaUnit;
        let curRentUnit = this.defaultRentUnit;
        if(this.stockStatusId != null ){
          curAreaSizeUnit = this.stockAreaUnit.id
          curRentUnit = this.stockRentUnit.id
        }
        leaseLeaseInfoVO = this.leaseForm.getFieldsValue();
        if(leaseLeaseInfoVO.leaseLeaseInfoDetailsVOList.length > 1){ //处理无效楼层数据
          leaseLeaseInfoVO.leaseLeaseInfoDetailsVOList = leaseLeaseInfoVO.leaseLeaseInfoDetailsVOList.filter((e,index)=>{
            return e.floorId !== undefined || index == 0
          })
        }
        leaseLeaseInfoVO.leaseLeaseInfoDetailsVOList.forEach((item,index)=>{
          item.areaSizeUnit = curAreaSizeUnit;
          item.stockStatusId = this.stockStatusId
        })
        leaseLeaseInfoVO.rentUnit = curRentUnit
        leaseLeaseInfoVO.leaseAttachmentDOS = this.fileList
        leaseLeaseInfoVO.colleagueDOS = this.colleagueList.map(e=>{
          return {id: e}
        })

        if(this.dateRange != null && this.dateRange.length > 0){
          if(leaseLeaseInfoVO != null ){
            leaseLeaseInfoVO.startTime = this.dateRange[0].format('YYYY-MM-01')
            leaseLeaseInfoVO.endTime = this.dateRange[1].format('YYYY-MM-01')
          }
        }
        console.log('leaseLeaseInfoVO',leaseLeaseInfoVO)
        return leaseLeaseInfoVO
      },
      handleSearch(customerName){
        setTimeout(()=>{
          customerApi.queryByName({name: customerName}).then(res => {
            this.customerList = res.data
          })
        },300);
      },
      init(){
        if(this.defaultLeaseInfoVO){
          this.leaseInfoVO = this.defaultLeaseInfoVO
          this.leaseLeaseInfoDetailsVOList = this.leaseInfoVO.leaseLeaseInfoDetailsVOList
          if(this.defaultLeaseInfoVO.fileDOList && this.fileList.length == 0){
            this.setFileList(this.defaultLeaseInfoVO.fileDOList);
          }
          if(this.defaultLeaseInfoVO.leaseAttachmentDOS && this.fileList.length == 0){
            this.setAttachmentList(this.defaultLeaseInfoVO.leaseAttachmentDOS);
          }
          Promise.all(
            [
              this.initMansionOptionsWithMansionid(this.leaseInfoVO.mansion),
              this.initMansionFloorOptions(this.leaseInfoVO.mansion),
              this.initCustomerOptions(this.leaseInfoVO.customerId)
            ]
          ).then(()=>{

            if(this.leaseInfoVO.startTime != '~' && this.leaseInfoVO.startTime){
              this.dateRange = [this.$moment(this.leaseInfoVO.startTime),this.$moment(this.leaseInfoVO.endTime)]
            }
            if(this.leaseInfoVO.inTime != '~' && this.leaseInfoVO.inTime){
              this.leaseInfoVO.inTime = this.$moment(this.leaseInfoVO.inTime)
            }
            if(this.leaseInfoVO.signTime != '~' && this.leaseInfoVO.signTime){
              this.leaseInfoVO.signTime = this.$moment(this.leaseInfoVO.signTime)
            }
            this.colleagueList = this.leaseInfoVO.colleagueDOS != null ? this.leaseInfoVO.colleagueDOS.map(e=>{return e.id}) : []
            this.leaseInfoVO.agent = this.leaseInfoVO.agent == '0' ? undefined : this.leaseInfoVO.agent;
            if(this.leaseInfoVO.dueTime == 0){
              this.leaseInfoVO.dueTime = undefined
            }
            this.leaseForm.setFieldsValue(this.leaseInfoVO)
          })
        }else if(this.leaseId){
          this.initLeaseInfoVO().then(()=>{
            Promise.all(
              [
                this.initMansionOptionsWithMansionid(this.leaseInfoVO.mansion),
                this.initMansionFloorOptions(this.leaseInfoVO.mansion),
                this.initCustomerOptions(this.leaseInfoVO.customerId)
              ]
            ).then(()=>{
              this.currMansionId = this.leaseInfoVO.mansion;
              this.defaultAreaUnit = this.leaseInfoVO.leaseAreaUnit;
              this.defaultRentUnit = this.leaseInfoVO.rentUnit;
              console.log(this.leaseInfoVO)
              if(this.leaseInfoVO.startTime != '~' && this.leaseInfoVO.startTime) {
                this.dateRange = [this.$moment(this.leaseInfoVO.startTime), this.$moment(this.leaseInfoVO.endTime)]
                console.log(this.dateRange)
              }
              if(this.leaseInfoVO.inTime != '~' && this.leaseInfoVO.inTime){
                this.leaseInfoVO.inTime = this.$moment(this.leaseInfoVO.inTime)
              }
              if(this.leaseInfoVO.signTime != '~' && this.leaseInfoVO.signTime){
                this.leaseInfoVO.signTime = this.$moment(this.leaseInfoVO.signTime)
              }
              this.colleagueList = this.leaseInfoVO.colleagueDOS != null ? this.leaseInfoVO.colleagueDOS.map(e=>{return e.id}) : []
              this.leaseInfoVO.agent = this.leaseInfoVO.agent == '0' ? undefined : this.leaseInfoVO.agent;
              if(this.leaseInfoVO.dueTime == 0){
                this.leaseInfoVO.dueTime = undefined
              }
              this.leaseForm.setFieldsValue(this.leaseInfoVO)
            })
          })
        }else if(this.customerVO){//客户详情新增租约
          this.leaseForm.setFieldsValue({rentUnit:this.defaultRentUnit})
          this.leaseLeaseInfoDetailsVOList[0]["areaSizeUnit"] = this.defaultAreaUnit
          this.customerList = [];
          let customerDO = {
            id:this.customerVO.id,
            companyName:this.customerVO.companyName,
            companySortNameCn:this.customerVO.companySortNameCn,
          }
          this.customerList.push(customerDO);
          this.$nextTick(()=>{
            this.leaseForm.setFieldsValue({
              leaseLeaseInfoDetailsVOList: this.leaseLeaseInfoDetailsVOList,
              customerId: this.customerVO.id
            })
          })
        }else if(this.unitVO){ //空置信息新增租约
          this.initMansionOptionsWithMansionid(this.unitVO.mansionId);//查询楼宇楼层信息
          this.initMansionFloorOptions(this.unitVO.mansionId);//查询楼层信息
          this.currMansionId = this.unitVO.mansionId;
          console.log('stockRentUnit',this.stockRentUnit)
          console.log('stockAreaUnit',this.stockAreaUnit)
          this.leaseForm.setFieldsValue({rentUnit:this.stockRentUnit.shortName})
          this.defaultAreaUnit = this.stockAreaUnit.shortName
          this.leaseLeaseInfoDetailsVOList[0]["areaSizeUnit"] = this.defaultAreaUnit
          this.leaseLeaseInfoDetailsVOList[0]["areaSize"] = this.unitVO.area == undefined ? undefined : this.$utils.commafyback(this.unitVO.area)
          this.leaseLeaseInfoDetailsVOList[0]["floorId"] = this.unitVO.floorId
          this.leaseLeaseInfoDetailsVOList[0]["mansionId"] = this.unitVO.mansionId
          this.leaseLeaseInfoDetailsVOList[0]["unitCodes"] = this.unitVO.unit
          this.$nextTick(()=>{
            this.leaseForm.setFieldsValue({
              customerId: undefined,
              mansion: this.unitVO.mansionId,
              rent:this.unitVO.rent == undefined ? undefined : this.$utils.commafyback(this.unitVO.rent),
              leaseLeaseInfoDetailsVOList: this.leaseLeaseInfoDetailsVOList
            })
          })
        }else{
          if(this.defaultCustomerId){
            this.initCustomerOptions(this.defaultCustomerId)
          }
          this.leaseLeaseInfoDetailsVOList[0]["areaSizeUnit"] = this.defaultAreaUnit
          this.$nextTick(()=>{
            this.leaseForm.setFieldsValue({
              customerId:this.defaultCustomerId ? this.defaultCustomerId:undefined,
              leaseLeaseInfoDetailsVOList: this.leaseLeaseInfoDetailsVOList,
              rentUnit:this.defaultRentUnit,
            })
          })
        }
        this.initCompetitors()
      },
      initCompetitors(){
        colleagueApi.selectAll().then(res=>{
          if(res.code == 1){
            this.competitors = res.data.records
          }
        })
      },
      initCustomerOptions(id){
        let p = new Promise((resolve,reject)=>{
          customerApi.selectOne(id).then(res=>{
            if(res.code == 1){
              this.customerList = [res.data]
              resolve()
            }else{
              reject()
            }
          })
        })
        return p
      },
      initLeaseInfoVO(){
        let p = new Promise((resolve,reject)=>{
          leaseApi.selectOne(this.leaseId).then(res=>{
            if(res.code == 1){
              let temp = JSON.stringify(res.data)
              this.leaseInfoVO = JSON.parse(temp.replace(/\"~\"/g,null))
              let index = 0
              this.leaseLeaseInfoDetailsVOList = this.leaseInfoVO.leaseLeaseInfoDetailsVOList
              if(this.leaseInfoVO.fileDOList){
                this.setFileList(this.leaseInfoVO.fileDOList);
              }
              resolve()
            }else{
              reject()
            }
          })
        })
        return p
      },
      setAttachmentList(fileArr) {
        this.fileList = [];
        if(fileArr.length > 0){
          fileArr.forEach(file=>{
            let fileDO={
              fileId:file.fileId,
              fileName:file.fileName
            }
            this.fileList.push(fileDO);
          })
        }
      },
      setFileList(fileArr){
        this.fileList = [];
        if(fileArr.length > 0){
          fileArr.forEach(file=>{
            let fileDO={
              fileId:file.id,
              fileName:file.fileName
            }
            this.fileList.push(fileDO);
          })
        }
      },
      initMansionOptionsWithMansionid(id){
        if(id){
          let p = new Promise((resolve,reject)=>{
            mansionApi.selectOne(id,2).then(res=>{
              if(res.code == 1){
                this.mansionOptions = [res.data];
                resolve()
              }else{
                reject()
              }
            })
          })
          return p
        }
      },
      initMansionOptions(value){
        if(value == null || value == ''){
          return
        }
        mansionApi.listAll({queryText: value}).then(res=>{
          if(res.code == 1){
            this.mansionOptions = res.data
          }
        })
      },
      mansionIdChange(mansionId){
        this.currMansionId = mansionId;
        this.clearFloorList();
        this.initMansionFloorOptions(mansionId);
      },
      initMansionFloorOptions(mansionId){
        if(mansionId){
          mansionFloorApi.listByMansionId(mansionId).then(res=>{
            if(res.code == 1){
              this.floorOptions = res.data;
            }
          })
        }
      },
      clearFloorList(){
        this.leaseLeaseInfoDetailsVOList = null;
        this.leaseForm.setFieldsValue({
          leaseLeaseInfoDetailsVOList: null,
        })
        this.$nextTick(()=>{
          this.leaseLeaseInfoDetailsVOList = [{}];
          this.leaseForm.setFieldsValue({
            leaseLeaseInfoDetailsVOList: [{}],
          })
        })
      },
      openAddCustomerModal(){
        this.customerModalVisible = true;
      },
      onSuccess(file,fileId){
        this.fileList.push({fileId:fileId,fileName:file.name})
      },
      saveCustomer(){
        this.$refs.customerModel.submit();
      },
      saveSuccess(id,name,customer){
        this.customerList = [];
        let customerDO = {
          id:id,
          companyName:name,
          companySortNameCn: customer.companySortNameCn
        }
        this.customerList.push(customerDO);
        this.leaseForm.setFieldsValue({
          customerId: id
        })
        this.customerModalVisible = false;
      },
      submit(){
        new Promise((resolve, reject)=>{
          try {
            let leaseLeaseInfoVO = this.leaseForm.getFieldsValue();
            let curAreaSizeUnit = this.defaultAreaUnit;
            if(this.stockStatusId != null ){
              leaseLeaseInfoVO.stockStatusId = this.stockStatusId
              curAreaSizeUnit = this.stockAreaUnit.id
              leaseLeaseInfoVO.rentUnit = this.stockRentUnit.id
            }

            if(leaseLeaseInfoVO.leaseLeaseInfoDetailsVOList.length > 1){ //处理无效楼层数据
              leaseLeaseInfoVO.leaseLeaseInfoDetailsVOList = leaseLeaseInfoVO.leaseLeaseInfoDetailsVOList.filter((e,index)=>{
                return e.floorId !== undefined || index == 0
              })
            }
            leaseLeaseInfoVO.leaseLeaseInfoDetailsVOList.forEach((item,index)=>{
              item.areaSizeUnit = curAreaSizeUnit;
            });
            let leaseInfoTypeDO
            if(this.dealId){
              leaseInfoTypeDO = {businessId: this.dealId, type:1}
              leaseLeaseInfoVO.newLease = true
            }
            leaseLeaseInfoVO.leaseLeaseinfoTypeDO = leaseInfoTypeDO
            leaseLeaseInfoVO.leaseAttachmentDOS = this.fileList
            leaseLeaseInfoVO.colleagueDOS = this.colleagueList.map(e=>{
              return {id: e}
            })
            if(this.dateRange && this.dateRange.length == 2){
              leaseLeaseInfoVO.startTime = this.dateRange[0].format('YYYY-MM-DD')
              leaseLeaseInfoVO.endTime = this.dateRange[1].format('YYYY-MM-DD')
            }
            resolve(leaseLeaseInfoVO);
          }catch (e){
            reject();
          }
        });
      },
    }
  }
</script>

<style scoped lang="less">
  .addBottomBtn{
    background: #3B2E26;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    height: 30px;
    .addIcon{
      color: #ffffff;
      font-size: 12px;
    }
    .addBtnText{
      font-size: 12px;
      color: #ffffff;
      margin-left:4px;
    }
  }
  #addOldLease{
    .greyDiv{

    }
    .deleteBtn{
      margin-top: 10px;
      margin-right: 8px;
      cursor: pointer;
      .delIcon{
        font-size: 18px;
      }
    }
    .fileRow{
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      margin: 10px 0;
      .fileRowLeft{
        display: flex;
        flex-direction: row;
        align-items: center;
        .circle{
          width: 15px;
          height: 15px;
          border-radius: 50%;
          background: #FABE00;
        }
        .fileTitle{
          font-size: 14px;
          color: #333333;
          margin-left: 10px;
        }
        .fileTip{
          font-size: 12px;
          color: #999999;
          margin-top: 4px;
          margin-left: 4px;
        }
      }
    }
    .fileDiv{
      padding: 20px;
      background: rgba(248,249,251,0.62);
      border-radius: 0 0 4px 4px;
    }
    .fileItem{
      display: flex;
      flex-direction: row;
      align-items: center;
      padding: 10px 0;
      border-bottom: 1px solid #E7E7E7;
      .fileIcon{
        font-size: 20px;
      }
      .fileName{
        flex:1;
        font-size: 12px;
        color: #333333;
        margin: 0 20px;
      }
      .delIcon{
        font-size: 20px;
        cursor: pointer;
      }
    }
    .fileItem:last-child{
      border-bottom: 0px;
    }
    .noFileClass{
      height: 100px;
      padding: 20px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 12px;
      color: #999999;
    }
    .ant-form-item{
      padding: 0 10px;
    }
    .lease_floor{
      padding: 10px 0;
      position:relative;
      background: #F4F5F8;
      border-radius: 0 0 4px 4px;
    }
  }

  .addCustomerBtn{
    background: #3B2E26;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    height: 30px;
    .addIcon{
      color: #ffffff;
      font-size: 12px;
    }
  }

  /deep/.invisible-item{
    display:none;
  }
  /deep/.maximum-length{
    width:35px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
</style>
<style lang="less">
  .ant-select-dropdown-content{
    /deep/.invisible-item{
      display:initial !important;
    }
  }
</style>